import React, { useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const timeFrames = [
  "48 hours",
  "1 week",
  "1 month",
  "6 months",
  "12 months",
  "5 years",
];

const dataSets = {
  "48 hours": [
    { date: "Hour 1", value: 400 },
    { date: "Hour 2", value: 600 },
    { date: "Hour 3", value: 800 },
    { date: "Hour 4", value: 1200 },
    { date: "Hour 5", value: 1000 },
    { date: "Hour 6", value: 700 },
    { date: "Hour 7", value: 900 },
    { date: "Hour 8", value: 1100 },
    { date: "Hour 9", value: 500 },
    { date: "Hour 10", value: 800 },
    // Add more hours as needed...
  ],
  "1 week": [
    { date: "Mon", value: 400 },
    { date: "Tue", value: 1200 },
    { date: "Wed", value: 1000 },
    { date: "Thu", value: 700 },
    { date: "Fri", value: 900 },
    { date: "Sat", value: 1100 },
    { date: "Sun", value: 500 },
  ],
  "1 month": [
    { date: "1 Jan", value: 400 },
    { date: "4 Jan", value: 1200 },
    { date: "7 Jan", value: 1000 },
    { date: "10 Jan", value: 700 },
    { date: "13 Jan", value: 900 },
    { date: "16 Jan", value: 1100 },
    { date: "19 Jan", value: 500 },
    { date: "22 Jan", value: 800 },
    { date: "25 Jan", value: 1200 },
    { date: "28 Jan", value: 1000 },
    { date: "31 Jan", value: 700 },
  ],
  "6 months": [
    { date: "1 Jul", value: 400 },
    { date: "16 Jul", value: 1200 },
    { date: "1 Aug", value: 1000 },
    { date: "16 Aug", value: 700 },
    { date: "1 Sep", value: 900 },
    { date: "16 Sep", value: 1100 },
    { date: "1 Oct", value: 500 },
    { date: "16 Oct", value: 800 },
    { date: "1 Nov", value: 1200 },
    { date: "16 Nov", value: 1000 },
    { date: "1 Dec", value: 700 },
    { date: "16 Dec", value: 900 },
  ],
  "12 months": [
    { date: "Jan", value: 400 },
    { date: "Feb", value: 1200 },
    { date: "Mar", value: 1000 },
    { date: "Apr", value: 700 },
    { date: "May", value: 900 },
    { date: "Jun", value: 1100 },
    { date: "Jul", value: 500 },
    { date: "Aug", value: 800 },
    { date: "Sep", value: 1200 },
    { date: "Oct", value: 1000 },
    { date: "Nov", value: 700 },
    { date: "Dec", value: 900 },
  ],
  "5 years": [
    { date: "Jan 2021", value: 400 },
    { date: "Jul 2021", value: 1200 },
    { date: "Jan 2022", value: 1000 },
    { date: "Jul 2022", value: 700 },
    { date: "Jan 2023", value: 900 },
    { date: "Jul 2023", value: 1100 },
    { date: "Jan 2024", value: 500 },
    { date: "Jul 2024", value: 800 },
    { date: "Jan 2025", value: 1200 },
    { date: "Jul 2025", value: 1000 },
  ],
};

const ConversionChart = ({
  selectedCurrency,
  convertSelectedCurrency,
  conversionRate,
}) => {
  const [selectedTimeFrame, setSelectedTimeFrame] = useState("48 hours");
  const [data, setData] = useState(dataSets[selectedTimeFrame]);
  // const fetchData = async (timeFrame) => {
  //   const url = timeFrameUrls[timeFrame];
  //   if (!url) return console.error("Invalid time frame selected");

  //   try {
  //     const response = await fetch(url);
  //     const result = await response.json();
  //     setData(result);
  //     console.log("API Data:", result);
  //   } catch (error) {
  //     console.error("API Fetch Error:", error);
  //   }
  // };
  const handleTimeFrameChange = (timeFrame) => {
    setSelectedTimeFrame(timeFrame);
    setData(dataSets[timeFrame]);
  };
  return (
    <>
      <div className="flex items-center justify-between gap-4">
        <p className="text-2xl font-semibold ">
          {selectedCurrency?.currencyCode} to{" "}
          {convertSelectedCurrency?.currencyCode} conversion chart
        </p>
        <p className="text-2xl font-semibold ">
          1 {selectedCurrency?.currencyCode} ={" "}
          <span className="text-primary">{conversionRate}</span>{" "}
          {convertSelectedCurrency?.currencyCode}
        </p>
      </div>
      <p className="text-4xl font-bold py-6">
        1 {selectedCurrency?.currencyCode} = {conversionRate}{" "}
        {convertSelectedCurrency?.currencyCode}
      </p>
      <p className="text-2xl text-gray-400">Updated a few seconds ago</p>
      <h2 className="text-xl mb-4 text-center font-semibold">Time period</h2>
      <div className="flex gap-2 space-x-2 mb-4">
        {timeFrames.map((timeFrame) => (
          <button
            key={timeFrame}
            className={`px-4 py-2 rounded-primary ${
              selectedTimeFrame === timeFrame
                ? "bg-black text-primary border-black font-semibold"
                : "bg-transparent text-[#163300] border border-gray-500 font-semibold"
            }`}
            onClick={() => handleTimeFrameChange(timeFrame)}
          >
            {timeFrame}
          </button>
        ))}
      </div>

      <ResponsiveContainer width="100%" height={400}>
        <LineChart
          data={data}
          margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
        >
          <XAxis dataKey="date" />
          <Tooltip />
          <Line
            type="monotone"
            dataKey="value"
            stroke="#00C853"
            strokeWidth={2}
          />
          <YAxis domain={[300, 1300]} />
        </LineChart>
      </ResponsiveContainer>

      {/* <div className="flex gap-2 pt-2">
        <div className="w-14 h-5 bg-primary"></div>
        <p>Mid market rate</p>
      </div>
      <p className="py-3">
        We use the real, mid-market rate with no sneaky mark-up to hide the
        fees. <span className="underline">Learn more</span>
      </p> */}
    </>
  );
};

export default ConversionChart;
